'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = require('./utils/track');

var _track3 = _interopRequireDefault(_track2);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_OVER_EIGHTEEN, _propTypes3.default.number.isRequired);

function trackPreferencesUpdate() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_PREFERENCE_UPDATE + ' event');
    return (0, _track3.default)(_events.EVENT_PREFERENCE_UPDATE, (0, _defineProperty3.default)({}, _traits.TRAIT_OVER_EIGHTEEN, traits[_traits.TRAIT_OVER_EIGHTEEN]));
}

exports.default = trackPreferencesUpdate;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackPreferencesUpdate.js
// module id = 1649
// module chunks = 1